import React, { useState, useEffect, useRef } from "react"
import type { EditDay } from "../worktime"
import { Tooltip } from "antd"
import styles from "../worktime.module.scss"

interface EditTdProps {
  data: Partial<API.WorktimeDaily.timeEntry>
  editID: number
  onEdit: () => void
  onChange: (val: number) => void
}
// 编辑工时，只能减少
const EditDailyTd: React.FC<EditTdProps> = (props) => {
  const { data, editID } = props
  const defaultVal = data.hours
  const [val, setVal] = useState(defaultVal)
  const [showTip, setShowTip] = useState(false)
  const itemClick = () => {
    if (data.status === 1) {
      return
    }
    if (props.data.hours !== null && props.data.hours! <= 0) {
      return
    }
    setVal(() => props.data.hours)
    props.onEdit()
  }
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let inputVal = e.target.value
    let num = Number(inputVal)
    if ((num * 10) % 5 !== 0) {
      num = Math.floor(num)
      setShowTip(true)
    }
    if (num > props.data.hours!) {
      num = props.data.hours || 0
      setShowTip(true)
    }
    setVal(() => num)
    e.target.value = num + ""
    props.onChange(num)
  }
  return (
    <td
      className={`edit-td relative ${
        (props.data.hours === 0 || props.data.status === 1) && "text-gray-400"
      } ${
        props.data.hours !== undefined && props.data.hours <= 0
          ? "worktimeEditDisabled"
          : ""
      } ${props.data.activityID === 18 && "b-r"}`}
      onClick={itemClick}
    >
      {editID > 0 && editID === data.id ? (
        <React.Fragment>
          <div className="edit-input-box">
            <input
              disabled={data.status === 1}
              className="edit-input"
              type="number"
              step={0.5}
              value={val}
              onChange={onChange}
            />
          </div>
          {showTip && <InputTip onHide={() => setShowTip(false)}></InputTip>}
        </React.Fragment>
      ) : (
          props.data.hours
      )}
    </td>
  )
}
interface TipProps {
  onHide: () => void
}
const InputTip: React.FC<TipProps> = (props) => {
  useEffect(() => {
    setTimeout(() => {
      props.onHide()
    }, 1500)
  }, [])
  return (
    <div className="worktime-input-tip">
      工时修改只能为0.5的倍数且小于原工时
    </div>
  )
}

export default EditDailyTd
